import React, { useEffect } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import loginImg from '../../assets/images/Login.svg';
import CustomIcon from '../../assets/images/CustomIcon.svg';
import Group from '../../assets/images/Header.svg';
import { useNavigate } from 'react-router-dom';
import apiService from '../../services/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import globe from '../../assets/icons/global.svg';
import pic from '../../assets/icons/2024.svg';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [language, setLanguage] = React.useState('en');
  const [loading, setLoading] = React.useState(false);

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selection, setSelection] = React.useState('');

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
  };

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleRegisterClick = () => {
    // Navigate to the registration page (change the path to your desired route)
    setIsModalOpen(true);
  };

  const onDismiss = () => {
    setIsModalOpen(false); // Close modal without any action
  };

  const handleSelection = (selection) => {
    localStorage.setItem('registrationType', selection);
    setSelection(selection); // Set selection state (Internal or External)
    setIsModalOpen(false); // Close modal after selection
    navigate('/register'); // Navigate to registration page
  };

  const handleForget = () => {
    // Navigate to the registration page (change the path to your desired route)
    navigate('/ResetPassword');
  };

  const initialValues = {
    email: '',
    password: '',
    rememberMe: false,
  };

  // Form validation (you can use validation libraries like Yup)
  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    if (!values.password) {
      errors.password = 'Password is Required';
    }
    return errors;
  };

  // Submit handler
  const onSubmit = async (values) => {
    const url = 'login';

    try {
      setLoading(true);
      const response = await apiService.post(url, values, {});

      localStorage.setItem('token', response?.accessToken);

      localStorage.setItem('user', JSON.stringify(response?.user));
      if (response?.user) {
        toast.success('Login Successfully', { toastId: '19' });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.error || 'Unexpected Error', {
        toastId: '98',
      });
    }
    setLoading(false);
  };

  let isRtl = language === 'ar';

  useEffect(() => {
    const isAuthenticated = !!localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (isAuthenticated && user) {
      if (user?.role === 'physician_management') {
        navigate('/dashbaord');
      } else if (
        user?.role === 'hospital_manager' ||
        user?.role === 'cluster_manager'
      ) {
        navigate('/dashbaord');
      } else {
        navigate('/dashbaord');
      }
    }
  }, []);

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-30">
          <div className="bg-white rounded-lg shadow-md w-1/3">
            <div className="px-4 pt-4 pb-2 flex space-x-3">
              <div>
                <h3 className="text-lg font-medium text-gray-900">
                  Choose Registration Type
                </h3>
                <p className="text-sm text-gray-600">
                  Please select whether you are registering as an internal or
                  external practitioner.
                </p>
              </div>
            </div>
            <div className="flex justify-around p-3 border-t border-[#E2E4E9]">
              <button
                onClick={() => handleSelection('Internal')}
                className="px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-200 border border-[#E2E4E9]"
              >
                Internal
              </button>
              <button
                onClick={() => handleSelection('External')}
                className="px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-200 border border-[#E2E4E9]"
              >
                External
              </button>
            </div>
            <div className="flex justify-end p-3 border-t border-[#E2E4E9]">
              <button
                onClick={() => onDismiss()}
                className="px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-200 border border-[#E2E4E9]"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="font-[sans-serif]  h-screen  overflow-hidden">
        <div
          className="grid lg:grid-cols-2 items-center gap-4 h-full"
          dir={isRtl ? 'rtl' : 'ltr'}
        >
          {/* Form Section */}

          <div
            style={{ height: '100%' }}
            className="flex flex-col justify-around"
          >
            <div>
              <img
                src={Group}
                style={{ padding: '24px 0px 0px 44px' }}
                className=""
                alt="Custom Icon"
              />
              <div
                style={{ width: '392px', margin: '0 auto' }}
                className="w-full "
              >
                <Formik
                  initialValues={initialValues}
                  validate={validate}
                  onSubmit={onSubmit}
                >
                  {({ setFieldValue }) => (
                    <Form>
                      <div className="text-center">
                        <img
                          src={CustomIcon}
                          className="mx-auto"
                          alt="Custom Icon"
                        />
                        <h5
                          style={{
                            fontSize: '24px',
                            fontWeight: '500',
                            lineHeight: '32px',
                            textAlign: 'center',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                          }}
                        >
                          Login to your account
                        </h5>
                        <p
                          style={{
                            color: '#525866',
                            paddingTop: '5px',
                            fontSize: '16px',
                            fontWeight: '400',
                            lineHeight: '24px',
                            letterSpacing: '-0.011em',
                            textAlign: 'center',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                          }}
                        >
                          Enter your details to login.
                        </p>
                      </div>

                      <div className="pt-1 pb-1" style={{ width: '392px' }}>
                        <hr />
                      </div>

                      {/* Email Address Field */}
                      <div>
                        <label
                          style={{
                            color: '#0A0D14',
                            fontSize: '14px',
                            fontWeight: 500,
                            lineHeight: '20px',
                            letterSpacing: '-0.006em',
                            textAlign: 'left',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                          }}
                        >
                          Email Address
                        </label>
                        <div className="relative flex items-center w-[392px]">
                          <Field
                            name="email"
                            type="text"
                            required
                            className="w-[392px] h-[40px] border border-gray-300 focus:ring-[#2D9F75] text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[10px]"
                            placeholder="Enter email"
                          />
                        </div>
                        <ErrorMessage
                          name="email"
                          component="div"
                          style={{ color: 'red', fontSize: '12px' }}
                        />
                      </div>

                      {/* Password Field */}
                      <div className="mt-1">
                        <label
                          style={{
                            color: '#0A0D14',
                            fontSize: '14px',
                            fontWeight: 500,
                            lineHeight: '20px',
                            letterSpacing: '-0.006em',
                            textAlign: 'left',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                          }}
                        >
                          Password
                        </label>
                        <div className="relative flex items-center w-[392px]">
                          <Field
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            required
                            style={{ width: '392px', height: '40px' }}
                            className=" border border-gray-300 text-gray-800 bg-white focus:ring-[#2D9F75] focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[10px]"
                            placeholder="Enter password"
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#bbb"
                            stroke="#bbb"
                            className="w-[18px] h-[18px] absolute right-4 cursor-pointer"
                            viewBox="0 0 128 128"
                            onClick={togglePassword}
                          >
                            <path
                              d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z"
                              data-original="#000000"
                            ></path>
                          </svg>
                        </div>
                        <ErrorMessage
                          name="password"
                          component="div"
                          style={{ color: 'red', fontSize: '12px' }}
                        />
                      </div>

                      {/* Remember Me and Forgot Password */}
                      <div className="flex flex-wrap items-center justify-between gap-4 mt-4 w-[392px]">
                        <div className="flex items-center">
                          <Field
                            id="remember-me"
                            name="rememberMe"
                            type="checkbox"
                            className="h-4 w-4 shrink-0 text-blue-600 focus:ring-blue-500 border-gray-300 rounded-md"
                          />
                          <label
                            htmlFor="remember-me"
                            className="ml-3 block"
                            style={{
                              color: '#0A0D14',
                              fontSize: '14px',
                              fontWeight: 400,
                              lineHeight: '20px',
                              letterSpacing: '-0.006em',
                              textAlign: 'left',
                              textUnderlinePosition: 'from-font',
                              textDecorationSkipInk: 'none',
                            }}
                          >
                            Keep me Logged in
                          </label>
                        </div>
                        <div>
                          <a
                            onClick={handleForget}
                            style={{
                              fontSize: '14px',
                              fontWeight: 500,
                              lineHeight: '20px',
                              letterSpacing: '-0.006em',
                              textAlign: 'right',
                              textDecorationLine: 'underline',
                              textDecorationStyle: 'solid',
                              textUnderlinePosition: 'from-font',
                              textDecorationSkipInk: 'none',
                              color: '#525866',
                              cursor: 'pointer',
                            }}
                          >
                            Forgot Password
                          </a>
                        </div>
                      </div>

                      {/* Login Button */}
                      <div className="mt-8">
                        <button
                          type="submit"
                          className="w-[392px] h-[40px] border border-gray-300 text-sm tracking-wide rounded-[10px] text-white focus:outline-none px-3 py-2"
                          style={{
                            background:
                              'linear-gradient(0deg, #007A63, #007A63), linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)',
                          }}
                          disabled={loading}
                        >
                          {loading ? (
                            <svg
                              aria-hidden="true"
                              className="inline w-4 h-4 text-gray-200 animate-spin  fill-green-500"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          ) : (
                            'Login'
                          )}
                        </button>
                      </div>
                      {/* Register Button */}
                      <div className="my-2 flex items-center gap-1"></div>
                      <button
                        disabled={loading}
                        type="button"
                        onClick={handleRegisterClick}
                        className="border border-gray-300 text-sm tracking-wide rounded-[10px] focus:outline-none px-6 py-2"
                        style={{
                          border: '1px solid var(--stroke-sub-300, #CDD0D5)',
                          width: '392px',
                          height: '40px',
                        }}
                      >
                        <span
                          className="text-sm"
                          style={{
                            background:
                              'linear-gradient(0deg, #007A63, #007A63), linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)',
                            WebkitBackgroundClip: 'text', // This is required for text clipping in Webkit browsers (Chrome, Safari)
                            backgroundClip: 'text', // Non-Webkit support
                            color: 'transparent', // Make sure text color is transparent to show the gradient
                          }}
                        >
                          Register as a Physician
                        </span>
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>

            <div className="flex items-center justify-between  pl-2 pr-2 pt-2 ">
              <div
                style={{ fontFamily: 'inter' }}
                className="font-[400] text-[#525866] text-sm"
              >
                <img src={pic} alt="logo" />
              </div>
              <form className="flex items-center">
                <img src={globe} alt="logo" />
                <select
                  id="countries_disabled"
                  value={language}
                  onChange={handleLanguageChange}
                  style={{ fontFamily: 'inter' }}
                  className="custom-dropdown bg-[#fff] border-[#F6F8FA] font-[400] text-[#525866] text-sm rounded-lg focus:ring-[white] focus:border-[white] block w-[76px] p-2.5 "
                >
                  <option value="en">ENG</option>
                  <option value="ar">AR</option>
                </select>
              </form>
            </div>
          </div>
          {/* Image Section */}
          <div className="bg-[white] h-full hidden overflow-hidden lg:flex justify-center items-center pt-2 pb-2 pr-2">
            <img
              src={loginImg}
              className="w-full h-full  object-cover rounded-[10px]" // Apply radius to all sides
              alt="login-image"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
